/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { httpErrorCodes } from "constants/enums";

export const getStringIdForHttpErrorCode = httpErrorCode => {
  switch (httpErrorCode) {
    case httpErrorCodes.BAD_REQUEST:
      return "nopreview.error.badRequest";
    case httpErrorCodes.UNAUTHORIZED:
      return "nopreview.error.unauthorized";
    case httpErrorCodes.FORBIDDEN:
      return "nopreview.error.forbidden";
    case httpErrorCodes.NOT_FOUND:
      return "nopreview.error.previewFailed";
    case httpErrorCodes.NOT_ACCEPTABLE:
      return "nopreview.error.notAcceptable";
    case httpErrorCodes.UNSUPPORTED_MEDIA_TYPE:
      return "nopreview.error.unsupportedMediaType";
    case httpErrorCodes.TOO_MANY_REQUEST:
      return "nopreview.error.tooManyRequests";
    case httpErrorCodes.INTERNAL_SERVER_ERROR:
      return "nopreview.error.internalServerError";
    case httpErrorCodes.BAD_GATEWAY:
      return "nopreview.error.badGateway";
    case httpErrorCodes.SERVICE_UNAVAILABLE:
      return "nopreview.error.serviceUnavailable";
    case httpErrorCodes.GATEWAY_TIMEOUT:
      return "nopreview.error.gatewayTimeout";
    default:
      return "nopreview.error.generic";
  }
};
